import React, { Fragment } from 'react'
import StudentReview from '../student-review'
import 'styled-components/macro'
import { styled } from 'styled-components'
import {
	ClientFields,
	ClozeDropdown,
	ImageLabeling,
	StudentAnswer,
} from '@mission.io/question-toolkit'
import { getStudentDropdownScore } from '../../utils'
import { _tempTheme } from '../../utils/tempTheme'

interface ModalOptionsProps {
	children?: JSX.Element
	title: string
	index: number
	studentAnswer?: StudentAnswer
	question: ImageLabeling<ClientFields> | ClozeDropdown<ClientFields>
}

// Modal that works as wrapper for Image Labeling and ClozeDropdown Student Response.
export const DropdownReviewResponse = ({
	children,
	title,
	index,
	studentAnswer,
	question,
}: ModalOptionsProps): JSX.Element => {
	const score = getStudentDropdownScore(studentAnswer, question)

	return (
		<Fragment>
			<StudentReview index={index} prompt={title}>
				<ScoreWrapper>
					{score ? `${score.correct}/${score.total} Correct` : 'Did not answer'}
					{children}
				</ScoreWrapper>
			</StudentReview>
		</Fragment>
	)
}

const ScoreWrapper = styled.div`
	margin-top: ${_tempTheme.spacing2};
	font-family: ${({ theme }) => theme.fontFamily};
	font-style: normal;
	font-weight: ${_tempTheme.font_semibold};
	line-height: ${_tempTheme.text_lg};
	color: ${({ theme }) => theme.black};
	text-align: center;
	background: #ececff;
	border-radius: ${_tempTheme.spacing1};
	padding: ${_tempTheme.spacing8} ${_tempTheme.spacing4};
`

export default DropdownReviewResponse
